import { render } from "./CarNumberPage.vue?vue&type=template&id=4ffc1d7f"
import script from "./CarNumberPage.vue?vue&type=script&lang=js"
export * from "./CarNumberPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__